import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { CmsEffects } from '@app/b2b/core/cms/store/cms.effect';

@NgModule({
  imports: [EffectsModule.forFeature(CmsEffects)],
})
export class CmsModule {}
